import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Autosuggest from "react-autosuggest";
import Search from "../../assets/images/search.svg";
import "./styles.css";
import axios from "axios";
import { Modal } from "react-bootstrap";
import {
  clearSearch,
  SearchKeyword,
  SearchVal,
  SearchValAll,
} from "../../redux/auth/actions";
import { useHistory } from "react-router";
import useDebounce from "../../hooks/useDebounce";
import { Toast } from "../../components";
import SearchFilter from "../Advance-Search/SerchFilter";
import CryptoJS from "crypto-js";
function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

const AutoSuggestField = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [value, setValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [fetchData, setFetchData] = useState([]);
  const [allTests, setAllTests] = useState([]);
  const [searchLoader, setSearchLoader] = useState(false);
  console.log(searchLoader, "searchLoader")
  const [searchCriteria, setSearchCriateria] = useState("startwith");

  const [toastOpen, setToastOpen] = useState(false);
  const [openpopup, setOpenPopup] = useState(false)
  console.log(openpopup, "openpopup")
  const [toastMessage, setToastMessage] = useState("");
  const [suggestionsObject, setSuggestionsObject] = useState({});

  const debouncedSearchTerm = useDebounce(value, 400);


  const handlePopupClose = () => {
    setOpenPopup(false);
  };

  function getHighlightedText(text, highlight) {
    try {
      // Split on highlight term and include term into parts, ignore case
      const parts = text.split(new RegExp(`(${highlight})`, "gi"));
      return (
        <span>
          {" "}
          {parts.map((part, i) => (
            <span
              key={i}
              style={
                part.toLowerCase() === highlight.toLowerCase()
                  ? { fontWeight: "bold", backgroundColor: "#FF5C3C", color: "#fff" }
                  : {}
              }
            >
              {part}
            </span>
          ))}{" "}
        </span>
      );
    } catch (error) {
      onSuggestionsClearRequested();
    }
  }

  function renderSuggestion(suggestion) {
    return (
      <>
        <span>
          {getHighlightedText(
            suggestion.additionalName.toString().trim(),
            value.toString().trim()
          )}
        </span>
        <br></br>
        <span
          style={{ color: "blue" }}
        >{`Also Known as :      ${suggestion.name.toString()}`}</span>
        <br></br>
      </>
    );
  }

  function getSuggestionValue(suggestion) {
    setSuggestionsObject(suggestion);
    dispatch(SearchVal(suggestion));
    let encryptedId = CryptoJS.AES.encrypt(
      JSON.stringify(suggestion.uuid),
      "my-secret-key@123"
    ).toString();
    history.push({
      pathname: "/search-results",
      search: "?=" + suggestion.name.replace(/ /g, "-") + "&" + encryptedId,
    });
    return suggestion.name;
  }

  function highLigtSggestion(event) {
    console.log(event);
  }

  const apiFetch = async (val) => {
    setSearchLoader(true);
    setFetchData([]);
    setAllTests([]);
    onSuggestionsClearRequested();
    dispatch(SearchValAll([]));
    dispatch(SearchKeyword(""));
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/labtest/diagnostic/searchLists?searchType=${searchCriteria}&value=${val}`
      )
      .then((res) => {
        if (res.statusText === "OK" || res.status === 200) {
          let brdata = [];
          setAllTests(res.data.data);
          res.data.data.map((i) => {
            brdata.push({
              name: i.doc.standardisedtestname,
              additionalName: i.doc.partnerstestname,
              uuid: i.doc.testname_uuid,
            });
          });
          setFetchData(brdata);
          dispatch(SearchValAll(res.data.data));
          dispatch(SearchKeyword(value));
          setSearchLoader(false);
        } else {
          setAllTests([]);
          setSearchLoader(false);
          onSuggestionsClearRequested();
          // setToastOpen(true);
          setOpenPopup(true)
          // setToastMessage("We apologize for the inconvenience. The selected test(s) are currently not available in the selected location,you can try near by location or contact our team via WhatsApp at +2349010996000 for assistance");
          // setToastMessage("We couldn't find any results for your search. Contact our team on WhatsApp at +2349010996000 for assistance. We're here to help!")

          // setValue('')
          setFetchData([]);
        }
      })
      .catch((err) => {
        setAllTests([]);
        setFetchData([]);
        onSuggestionsClearRequested();
        setSearchLoader(false);
        // setToastOpen(true);
        setOpenPopup(true)
        // setToastMessage("We apologize for the inconvenience. The selected test(s) are currently not available in the selected location, you can try near by location or contact our team via WhatsApp at +2349010996000 for assistance");
        // setToastMessage("We couldn't find any results for your search. Contact our team on WhatsApp at +2349010996000 for assistance. We're here to help!")
      });
  };

  useEffect(() => {
    if (value) {
      setFetchData([]);
      apiFetch(value);
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    onSuggestionsClearRequested();
    setValue("");
  }, [searchCriteria]);

  function getSuggestions(value) {
    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === "") {
      return [];
    }

    const regex = new RegExp("^" + escapedValue, "i");

    return fetchData;
  }
  const onChange = (event, { newValue, method }) => {
    setValue(newValue);
    // apiFetch(newValue);
  };

  useEffect(() => {
    setSuggestions(getSuggestions(value));
  }, [fetchData]);
  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value));
  };

  const onSuggestionsClearRequested = () => {
    setFetchData([]);
    setSuggestions([]);
  };

  const inputProps = {
    // placeholder: "Search For Tests",
    placeholder: "Search from over 6000 tests",
    value,
    onChange: onChange,
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const handleSearch = (diff) => {
    if (diff) {
      if (allTests && allTests.length > 0) {
        // dispatch(SearchValAll(allTests))
        //dispatch(SearchKeyword(value));
        // history.push("/search-results");
        if (diff === "SEARCHPAGE") {
          history.push({
            pathname: "/search-results",
            search: "?=" + value.replace(/ /g, "-"),
          });
          setValue("");
        }
      } else {
        setToastOpen(true);
        // setToastMessage("We apologize for the inconvenience. The selected test(s) are currently not available in the selected location, you can try near by location or contact our team via WhatsApp at +2349010996000 for assistance");
        // setToastMessage("We couldn't find any results for your search. Contact our team on WhatsApp at +234 9010996000 for assistance. We're here to help!")
        setValue("");
      }
    }

    if (suggestions.length > 0) {
      let removedSpace = value.split(" ")[0];
      let data = suggestionsObject;
      // history.push("/search-results");
      data = {};
    }
  };

  const phoneNumber = "+2349010996000";
  const boldStyle = {
    fontWeight: 'bold',
    cursor: "grab",
    color: "#ff5c3c",
    fontSize: "15px"
  };

  const handleWhatsAppClick = (event) => {
    console.log(event, "click on the whatsapp num")
    const formattedPhoneNumber = phoneNumber.replace(/\D/g, ''); // Remove any non-numeric characters
    const whatsappLink = `https://api.whatsapp.com/send?phone=${formattedPhoneNumber}`;
    window.open(whatsappLink, '_blank');
  };

  return (
    <>
      <div style={{ display: "flex", width: "100%", margin: "0px 15px" }}>
        <div className="searchIcon">
          <img
            src={Search}
            style={{ width: "18px", height: "18px" }}
            alt="search"
          />
        </div>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={onSuggestionsFetchRequested}
          onSuggestionsClearRequested={onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps}
          placeholder="Search For Tests"
          // onSuggestionHighlighted={highLigtSggestion}
          onSuggestionSelected={(event) => {
            handleSearch(event);

            setValue("");
          }}
        />
        {!searchLoader ? (
          <div className="searchDiv">
            <button
              className="searchBtn"
              onClick={() => {
                handleSearch("SEARCHPAGE");
              }}
            >
              Search
            </button>
          </div>
        ) : (
          <div className="searchDiv">
            <button
              class="btn btn-primary"
              type="button"
              disabled
              style={{
                color: "white",
                backgroundColor: "#FF5C3C",
                borderColor: "#FF5C3C",
              }}
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </button>
          </div>
        )}


        <Modal
          show={openpopup}
          onHide={handlePopupClose}
          style={{ marginLeft: "8%" }}
        >
          <div className="parentContainer" style={{ marginTop: "253px", width: "113%" }}>
            <div style={{ marginTop: "200px !important", zIndex: "10000000 !important" }}>
              {/* <Modal.Header>
              </Modal.Header> */}
              <div>
                <p>We couldn't find any results for your search. Contact our team on WhatsApp at <a target="" onClick={handleWhatsAppClick} style={boldStyle}>{phoneNumber}</a> for assistance. We're here to help!</p>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div
                className="popup_btn"
                style={
                  { backgroundColor: "#FF5C3", display: "flex", justifyContent: "center" } //opacity: "0.5", cursor: "not-allowed"
                }
                onClick={() => {
                  setOpenPopup(false);
                }}
              >
                Close
              </div>
            </div>
          </div>
        </Modal>

        <Toast
          text={toastMessage}
          type="error"
          open={toastOpen}
          setClose={() => {
            setTimeout(() => {
              setToastOpen(false);
            }, 3000)
          }}
        />
      </div>
      <div style={{ display: "flex", width: "100%", margin: "0px 10px", justifyContent: "center" }}>
        <SearchFilter serachFilter={(event) => setSearchCriateria(event)} />
      </div>
    </>
  );
};

export default AutoSuggestField;
